// extracted by mini-css-extract-plugin
export default {"selectWrapper":"PermissionSelect_selectWrapper__T+uG+"};